import { use } from 'react';

import { LegacyContext } from '@/config/legacy';

export function useLegacy() {
    const context = use(LegacyContext);

    if (!context) {
        throw new Error('useLegacy must be used within a LegacyProvider');
    }

    return context;
}
